import { makeStyles } from "@material-ui/core/styles";
import { Box, IconButton, Tab, Tabs, withStyles } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import { useMapColorState } from "../../store/MapColorState";
import {
  mapLegendListState,
  mapLegendVisibleState,
  mapSelectedLegendState
} from "../../store/MapLegendState";
import { useRecoilCallback, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { toggleMapContentsVisibleWithID } from "../../store/MapContentsState";
import { isWXContents, toggleWeatherVisibleWithID } from "../../store/WeatherContentsState";
import { setForegroundAltitudeSelector } from "../../store/MapAltitudeState";
import { routePointEditingState } from "../../store/RoutePointEditingState";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    bottom: 0,
    right: 0,
    width: '500px',
    pointerEvents: 'none'
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  panel: {
    position:'relative',
    backgroundColor: "rgba(238,238,238,.7)",
    pointerEvents: 'auto',
    minHeight:50,
    '& >div': {
      fontSize:12,
      paddingTop:5,
      paddingBottom:5,
      paddingLeft:10,
      paddingRight:10
    }
  },
  closeButton: {
    position:'absolute',
    top:3,
    right:5
  }
}));

const LegendTabs = withStyles((theme) => ({
  root: {
    minHeight:32,
    borderBottom: '1px solid #e8e8e8'
  },
  scrollButtons: {
    backgroundColor: "rgba(238,238,238,.7)",
    pointerEvents: "auto",
    opacity: '1!important',
    '&.Mui-disabled svg': {
      opacity: 0
    }
  },
  indicator: {
    backgroundColor: '#1890ff',
  },
}))(Tabs);

const LegendTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 50,
    paddingTop: 0,
    paddingBottom: 0,
    minHeight:32,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(0),
    backgroundColor: "rgba(238,238,238,.7)",
    pointerEvents: 'auto',
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);


function TabPanel(props) {
  const { children, id, value, index, close, ...other } = props;
  const classes = useStyles();
  const handleClose = (event) => {
    close(event ,id);
  };
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={classes.panel}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
      <IconButton size='small' className={classes.closeButton} onClick={handleClose}>
        <CloseIcon/>
      </IconButton>
    </div>
  );
}

function ContentsLegendPanel() {
  const mapLegendVisible = useRecoilValue(mapLegendVisibleState);
  const mapLegendList = useRecoilValue(mapLegendListState);
  const [mapSelectedLegend, setMapSelectedLegend] = useRecoilState(mapSelectedLegendState);
  const setForegroundAltitude = useSetRecoilState(setForegroundAltitudeSelector);
  const routePointEditing = useRecoilValue(routePointEditingState);

  const {mapColor} = useMapColorState();
  const classes = useStyles();

  const handleChange = (event, activeTab) => {
    setMapSelectedLegend(activeTab)
    //選択された凡例に該当するaltitudeContentsListがある場合、並べ替えて全面に持ってくる
    setForegroundAltitude(mapLegendList[activeTab].id);
  };

  const toggleContents = useRecoilCallback(({set}) => id => {
    if (isWXContents(id)) {
      set(toggleWeatherVisibleWithID(id));
    } else {
      set(toggleMapContentsVisibleWithID(id));
    }
  });

  const handleClose = (event, id) => {
    event.stopPropagation();
    toggleContents(id);
  };

  const hidden = mapLegendList.length === 0 || !mapLegendVisible || routePointEditing;

  return (
    <div className={`${classes.root} ${mapColor}`}  hidden={hidden}>
      <div>
        <LegendTabs value={mapSelectedLegend} onChange={handleChange} aria-label="legend" variant="scrollable"
              scrollButtons={"auto"}>
          {mapLegendList.map(legend => {
            return <LegendTab key={legend.id}  label={legend.label}/>
          })}
        </LegendTabs>
        {mapLegendList.map((legend, idx) => {
          const LegendComponent = legend.component;
          const contents = legend.contents;
          return (
            <TabPanel key={legend.id} id={legend.id} value={mapSelectedLegend} index={idx} close={handleClose}>
             <LegendComponent contents={contents}/>
            </TabPanel>
          )
        })}
      </div>
    </div>
  )
}

export default ContentsLegendPanel;